import { AnyAction, Reducer } from 'redux';

export const STORE_FILES_2 = 'file2/files2-upload';
export const STORE_MATERIALFILES = 'materialfile/materialfiles-upload';

export const STORE_FILES_UPLOADED = 'file/files-uploaded-array';

export const STORE_PROGRESS = 'progress/file-upload';
export const STORE_MATERIAL_PROGRESS = 'materialprogress/file-upload';

export const STORE_ORDERDATADESIGN = 'design/order-data-api';
export const STORE_ORDERDATATAT = 'tat/order-data-api';
export const STORE_ORDERDATAMATE = 'material/order-data-api';
export const STORE_ORDERDATAMANUFACT = 'manufacturer/order-data-api';

export const STORE_ORDERDATABRANCH = 'branch/order-data-api';
export const STORE_BRANCH_DATA = 'branch/order-data';

export const STORE_MATERIAL = 'material/save-material';
export const STORE_TAT = 'tat/save-tat';
export const STORE_DESIGN = 'design/save-design';
export const STORE_MSG = 'msg/save-msgorder';
export const STORE_SENDING_INPROGRESS = 'send/sending-inprogress';

export interface DesignData {
    rowno: string;
    dtype: string;
}
export interface TatData {
    rowno: string;
    tattype: string;
}
export interface MaterialData {
    rowno: string;
    materialname: string;
}

export interface ManufacturerData {
    rowno: string;
    dest: string;
}
export interface BranchData {
    rowno: string;
    sbu_name: string;
}

export interface FileUploadState {
    files2: Array<File>;
    materialfiles: string;
    filesUploaded: Array<number>;
    progress: Array<number>;
    materialprogress: number;
    progressSelected: Array<number>;
    orderDataDesign: DesignData[];
    orderDataTat: TatData[];
    orderDataMaterial: MaterialData[];
    orderDataManufacturer: ManufacturerData[];
    orderDataBranch: BranchData[];
    branchType: string;
    saveMaterial: Array<string>;
    saveTat: Array<string>;
    saveDesign: Array<string>;
    saveMsg: Array<string>;
    sending: boolean;
}

const initialState: FileUploadState = {
    files2: [],
    materialfiles: '',
    filesUploaded: [],
    progress: [],
    materialprogress: 0,
    progressSelected: [],
    orderDataDesign: [],
    orderDataTat: [{
        rowno: '1',
        tattype: 'Next Day 7 AM'
    },
    ],
    orderDataMaterial: [],
    orderDataManufacturer: [],
    orderDataBranch: [{
        rowno: '1',
        sbu_name: 'General'
    }],
    branchType: '0',
    saveMaterial: [],
    saveTat: [],
    saveDesign: [],
    saveMsg: [],
    sending: false

};

const reducer: Reducer<FileUploadState> = (state: FileUploadState = initialState, action: AnyAction): FileUploadState => {
    switch (action.type) {
        case STORE_FILES_2:
            return {
                ...state,
                files2: action.files2,
            };
        case STORE_MATERIALFILES:
            return {
                ...state,
                materialfiles: action.materialfiles,
            };
        case STORE_FILES_UPLOADED:
            return {
                ...state,
                filesUploaded: action.filesUploaded,
            };
        case STORE_PROGRESS:
            return {
                ...state,
                progress: action.progress,
            };
        case STORE_MATERIAL_PROGRESS:
            return {
                ...state,
                materialprogress: action.materialprogress,
            };
        case STORE_MATERIAL:
            return {
                ...state,
                saveMaterial: action.saveMaterial
            };
        case STORE_TAT:
            return {
                ...state,
                saveTat: action.saveTat
            };
        case STORE_DESIGN:
            return {
                ...state,
                saveDesign: action.saveDesign
            };
        case STORE_MSG:
            return {
                ...state,
                saveMsg: action.saveMsg
            };
        case STORE_ORDERDATADESIGN:
            return {
                ...state,
                orderDataDesign: action.orderDataDesign
            };
        case STORE_ORDERDATATAT:
            return {
                ...state,
                orderDataTat: action.orderDataTat
            };
        case STORE_ORDERDATAMATE:
            return {
                ...state,
                orderDataMaterial: action.orderDataMaterial
            };
        case STORE_ORDERDATAMANUFACT:
            return {
                ...state,
                orderDataManufacturer: action.orderDataManufacturer
            };
        case STORE_ORDERDATABRANCH:
            return {
                ...state,
                orderDataBranch: action.orderDataBranch
            };
        case STORE_BRANCH_DATA:
            return {
                ...state,
                branchType: action.branchType
            };
        case STORE_SENDING_INPROGRESS:
            return {
                ...state,
                sending: action.sending
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/fileUpload.tsx